<template>
  <section class="brand">
    <div class="brand__layout">
      <!-- Left: image -->
      <div class="brand__image-wrap">
<!--        <img-->
<!--          src="https://images.unsplash.com/photo-1501004318641-b39e6451bec6?w=900&q=80&auto=format&fit=crop"-->
<!--          alt="Natural ingredients"-->
<!--          class="brand__image"-->
<!--        />-->
        <img src="@/assets/images/s2.png" class="brand__image">
        <div class="brand__image-badge">
          <span class="brand__badge-year">2026</span>
          <span class="brand__badge-text">Est.</span>
        </div>
      </div>

      <!-- Right: content -->
      <div class="brand__content">
        <span class="section-label">Our Story</span>
        <h2 class="brand__title">
          향이 약한 디퓨저는 <br>
          <em>만들지 않습니다</em>
        </h2>
        <div class="divider" />
        <p class="brand__body">
          Perfume Wiz는 단순히 향을 만드는 것이 아니라 <br>
          공간 전체를 채우는 향의 존재감을 만듭니다. <br>
          일반 디퓨저보다 높은 향료 함량과
          균형 잡힌 블렌딩을 통해<br>
          문을 열고 들어오는 순간 공간의 분위기가 달라지도록 설계되었습니다.
        </p>
        <p class="brand__body">
          향은 단순한 냄새가 아니라
          공간의 첫 인상을 결정합니다.<br>
          Perfume Wiz는
          강하지만 부담스럽지 않은 향의 밸런스를 연구합니다.
        </p>

        <div class="brand__stats">
          <div class="brand__stat" v-for="stat in stats" :key="stat.label">
            <span class="brand__stat-value">{{ stat.value }}</span>
            <span class="brand__stat-label">{{ stat.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BrandSection',
  data() {
    return {
      stats: [
        { value: '20~30%', label: '향료함량' },
        { value: '120ml', label: '대용량 디퓨저' },
        { value: '4~6주', label: '지속되는 향' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables';

.brand {
  background-color: $color-ivory;
  display: flex;
  align-items: center;
  overflow: hidden;

  @media (max-width: $bp-mobile) {
    align-items: center;
    height: auto !important;
  }
}

.brand__layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100%;
  width: 100%;

  @media (max-width: $bp-mobile) {
    grid-template-columns: 1fr;
  }
}

.brand__image-wrap {
  position: relative;
  overflow: hidden;

  @media (max-width: $bp-mobile) {
    height: 40vh;
  }
}

.brand__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: transform 0.8s ease;

  &:hover {
    transform: scale(1.04);
  }
}

.brand__image-badge {
  position: absolute;
  bottom: 40px;
  right: -20px;
  width: 100px;
  height: 100px;
  background-color: $color-gold;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: $bp-mobile) {
    display: none;
  }
}

.brand__badge-year {
  font-family: $font-heading;
  font-size: 22px;
  font-weight: 500;
  color: $color-white;
  line-height: 1;
}

.brand__badge-text {
  font-family: $font-body;
  font-size: 10px;
  letter-spacing: 0.12em;
  color: rgba($color-white, 0.85);
  text-transform: uppercase;
}

.brand__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 80px 80px 80px 72px;

  @media (max-width: $bp-tablet) {
    padding: 60px 48px;
  }

  @media (max-width: $bp-mobile) {
    padding: 28px 24px 60px;
  }
}

.brand__title {
  font-family: $font-heading;
  font-size: clamp(36px, 3.5vw, 52px);
  font-weight: 400;
  color: $color-forest;
  line-height: 1.15;

  em {
    font-style: italic;
    color: #9a4444;
  }
}

.brand__body {
  font-family: $font-body;
  font-size: 15px;
  font-weight: 300;
  line-height: 1.9;
  color: rgba($color-forest, 0.75);
  margin-bottom: 20px;
  max-width: 460px;

  @media (max-width: $bp-mobile) {
    font-size: 14px !important;
  }
}

.brand__stats {
  display: flex;
  gap: 48px;
  margin-top: 12px;

  @media (max-width: $bp-mobile) {
    gap: 28px;
  }
}

.brand__stat {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.brand__stat-value {
  font-family: $font-heading;
  font-size: 32px;
  font-weight: 500;
  color: $color-forest;
  line-height: 1;
}

.brand__stat-label {
  font-family: $font-body;
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.08em;
  color: rgba($color-forest, 0.55);
  text-transform: uppercase;
}
</style>
